module.exports = {
  draftsList: 'List of Deactivations',
  closedList: 'Closed List',
  editImage: {
    title: 'Edit Image',
  },
  header: {
    title: 'The Daily',
    buttonCreate: 'Create',
    buttonPublish: 'Publish',
  },
  table: {
    title: {
      index: 'NO',
      show: 'Active',
      title: 'TITLE',
      link: 'DEEP LINK TYPE',
      partner: 'PARTNER',
      status: 'STATUS',
      action: 'ACTION',
      country: 'COUNTRY',
    },
    tooltip: {
      edit: 'Edit',
      delete: 'Delete',
      inactive: 'InActive',
      active: 'Active',
      schedule: 'Schedule',
    },
    popup: {
      title: 'Confirm',
      okBtn: 'Yes',
      cancelBtn: 'No',
      delete: 'Are you sure to delete this The Daily?',
      edit: 'Are you sure to edit this The Daily?',
      enable: 'Are you sure you want to enable this The Daily?',
      disable: 'Are you sure you want to disable this The Daily?',
      confirmPassword: 'Please input your password to confirm.',
    },
  },
  form: {
    image3x4: 'Please upload an 3*4 image or video',
    imageUpload: '*Upload an image/video',
    title: 'Title',
    subTitle: 'Subtitle',
    link: 'Link',
    linkType: 'Page Type',
    countries: 'Countries',
    btnUpdateTheDaily: 'Update',
    btnCreateTheDaily: 'Add',
    scheduleTile: 'Schedule The Daily',
    updateTheDaily: 'Edit The Daily',
    createTheDaily: 'Add The Daily',
    backgroundColor: 'Background Color',
    titleColor: 'Title Color',
    subColor: 'Subtitle Color',
    cta: 'CTA',
    ctaTextColor: 'CTA Text Color',
    ctaBackgroundColor: 'CTA Background Color',
    btnSubmit: 'Submit',
    category: 'Category',
    ctaDeepLink: 'Feature App Deeplink',
    ctaCMS: 'CMS ID',
    contentType: 'Content Type',
    contentFormat: 'Content Format',
  },
  validate: {
    titleBlank: 'Please input title!',
    countryBlank: 'Please select country!',
    linkBlank: 'Please input a link!',
    linkTypeBlank: 'Please select page type!',
    imageBlank: 'Please input an image or video!',
    ctaBlank: 'Please input a CTA!',
    ctaCMSBlank: 'Please input a CMS ID!',
    ctaDeepLinkBlank: 'Please select a Feature App Deeplink!',
    contentTypeBlank: 'Please input a content type!',
    contentFormatBlank: 'Please input a content format!',
  },
  tab: {
    detail: {
      form: {
        time: {
          title: 'Time',
          startTimePlaceholder: 'Start time',
          endTimePlaceholder: 'End time',
          startDatePlaceholder: 'Start date',
          endDatePlaceholder: 'End date',
        },
        validate: {
          titleBlank: 'Please input title.',
          countryBlank: 'Please select Country',
          descriptionBlank: 'Please input description.',
          startBeforeNow: 'The start date time must be after now.',
          endBeforeNow: 'The end date time must be after now.',
          startBeforeEnd: 'The start date must be before the end date time.',
          startTimeBlank: 'Please input start time.',
          endTimeBlank: 'Please input end time.',
          startDateBlank: 'Please input start date.',
          endDateBlank: 'Please input end date.',
          productNameBlank: 'Please input product name.',
          productDescriptionBlank: 'Please input product description.',
          productVideoTypeBlank: 'Please input product video type.',
          productVideoIdBlank: 'Please input product video id.',
          frequencyBlank: 'Please input push notifications reminder frequency.',
        },
      },
    },
  },
  message: {
    error: {
      uploadImage: 'There was an error while uploading the image. Please try again',
      requireUpload: 'Please upload an image.',
      maxItem: 'Please disable another tile before enabling a new one.',
    },
    success: {
      updateTheDaily: 'The Daily successfully updated.',
      createTheDaily: 'The Daily successfully added.',
      scheduleTile: 'The Daily successfully scheduled.',
      deleteTheDaily: 'The Daily successfully deleted.',
    },
  },
};
